export default "__VITE_ASSET__Cdy3Z0Qm__";